import { render, staticRenderFns } from "./maintainedTagDialog.vue?vue&type=template&id=1531c77b&scoped=true&"
import script from "./maintainedTagDialog.vue?vue&type=script&lang=js&"
export * from "./maintainedTagDialog.vue?vue&type=script&lang=js&"
import style0 from "./maintainedTagDialog.vue?vue&type=style&index=0&id=1531c77b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1531c77b",
  null
  
)

export default component.exports